import React from 'react';
import '@topcon/te-web/dist/te-spacing';
import { TeEventListeners, useWebComponentWrapper } from './utils/utils';

interface Props extends TeEventListeners {
  size?: number;
  direction?: 'y' | 'x';

  children?: React.ReactChild | React.ReactChild[];
}

export default function TeSpacing(props: Props): JSX.Element {
  const ref = React.useRef<HTMLElement>(null);
  useWebComponentWrapper(props, ref);
  return <te-spacing ref={ref}>{props.children}</te-spacing>;
}

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      'te-spacing': any;
    }
  }
}
